















import { Component, Vue, Prop } from 'vue-property-decorator';
import { State } from 'vuex-class';
// @ts-ignore
import Icon from 'vue-awesome/components/Icon';

@Component({
	components: {
		Icon,
	},
})
export default class AllyInputStatusButton extends Vue {
	@State private loading!: boolean;

	private handleInputWrapper() {
		this.$emit('handleInput');
	}
}
